import {useContext} from 'react';
import {LocalizationContext} from 'app/contexts';

const useLocalizationContext = () => useContext(LocalizationContext);

export default useLocalizationContext;
